import  Drawer from "./Ui/Drawer";
import DrawerHandle from "./Ui/DrawerHandle";
import OffCanvas from "./Ui/OffCanvas";
import SnapNavigation from "./Ui/SnapNavigation";
import MobileNavigationToggle from "./Ui/MobileNavigationToggle";
import DetachNavbar from "./Ui/DetachNavbar";
import SlowLink from "./Ui/SlowLink";

export default {
    DetachNavbar,
    Drawer,
    DrawerHandle,
    OffCanvas,
    SnapNavigation,
    SlowLink,
    MobileNavigationToggle
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Ui.js